export enum StorageStrategies {
	Local = 'local_strategy',
	Session = 'session_strategy',
	InMemory = 'in_memory_strategy'
}
